module.exports = __webpack_public_path__ + "static/media/checks.a9ee77a9.png";